import { TranslationKeys } from './types/translationStructure';

export const fasterPayoutsEn = {
  previousPayments: 'Previous payouts',
  title: 'Payouts FPS',
  status: {
    Created: 'Created',
    Ready: 'In processing',
    Success: 'Success',
    Rejected: 'Rejected',
    Pending: 'Pending',
  },
  dataTitle: 'Payment details',
  name: 'Name',
  phone: 'Phone',
  bankName: 'Bank',
  orderId: 'Payout ID',
  processingName: 'Processing',
  payoutPurpose: 'Payout purpose',
  recipientAccount: 'Recipient account number',
  history: 'Operations history',
  requisites: 'Requisites',
  tooltip: 'Faster payout',
  downloadPDF: 'Download PDF',
  userData: 'Additional data',
  source: 'Payout method',
} as const;

export const fasterPayoutsRu: TranslationKeys<typeof fasterPayoutsEn> = {
  previousPayments: 'Предыдущие выплаты',
  title: 'Выплаты СБП',
  status: {
    Created: 'Создано',
    Ready: 'В обработке',
    Success: 'Успешно',
    Rejected: 'Отклонено',
    Pending: 'В обработке',
  },
  name: 'ФИО',
  dataTitle: 'Данные платежа',
  bankName: 'Банк',
  phone: 'Телефон',
  history: 'История операций',
  orderId: 'ID выплаты',
  processingName: 'Процессинг',
  payoutPurpose: 'Назначение выплаты',
  recipientAccount: 'Номер счёта получателя',
  requisites: 'Реквизиты',
  tooltip: 'Выплата СБП',
  downloadPDF: 'Скачать PDF',
  userData: 'Дополнительные данные',
  source: 'Способ выплаты',
} as const;
